import { takeLatest, call, put } from 'redux-saga/effects';
import { client } from '../modules/apollo';
import { QUOTE_FOR_REQUEST, PUBLIC_QUOTE, QUOTE_BY_UUID } from '../queries';
import {
  FETCH_QUOTE_FOR_REQUEST_START,
  FETCH_QUOTE_FOR_REQUEST,
  FETCH_QUOTE_FOR_REQUEST_ERROR,
  FETCH_PUBLIC_QUOTE_START,
  FETCH_PUBLIC_QUOTE,
  FETCH_PUBLIC_QUOTE_ERROR,
  FETCH_QUOTE_BY_UUID_START,
  FETCH_QUOTE_BY_UUID,
  FETCH_QUOTE_BY_UUID_ERROR,
  GET_QUOTE_FOR_REQUEST,
  GET_PUBLIC_QUOTE,
  GET_QUOTE_BY_UUID,
} from '../constants/action-types';

interface FetchQuoteForRequestAction {
  payload: {
    quoteId: string;
    eventId: string;
    requestId: string;
  };
  type: string;
}

interface FetchPublicQuoteAction {
  payload: {
    quoteId: string;
  };
  type: string;
}

interface FetchQuoteByUuidAction {
  payload: {
    quoteUuid: string;
  };
  type: string;
}

function* fetchQuoteForRequestSaga({ payload }: FetchQuoteForRequestAction) {
  yield put({ type: FETCH_QUOTE_FOR_REQUEST_START });

  try {
    const response = yield call(client.query, {
      query: QUOTE_FOR_REQUEST,
      variables: {
        quoteId: payload.quoteId,
        eventId: payload.eventId,
        requestId: payload.requestId,
      },
      fetchPolicy: 'network-only',
    });

    const [quote] = response.data.quotes || [];
    yield put({
      type: FETCH_QUOTE_FOR_REQUEST,
      payload: quote,
    });
  } catch (error) {
    yield put({
      type: FETCH_QUOTE_FOR_REQUEST_ERROR,
      payload: error,
    });
  }
}

function* fetchPublicQuoteSaga({ payload }: FetchPublicQuoteAction) {
  yield put({ type: FETCH_PUBLIC_QUOTE_START });

  try {
    const response = yield call(client.query, {
      query: PUBLIC_QUOTE,
      variables: {
        quoteId: payload.quoteId,
      },
      fetchPolicy: 'network-only',
    });

    yield put({
      type: FETCH_PUBLIC_QUOTE,
      payload: response.data.publicQuote,
    });
  } catch (error) {
    yield put({
      type: FETCH_PUBLIC_QUOTE_ERROR,
      payload: error,
    });
  }
}

function* fetchQuoteByUuidSaga({ payload }: FetchQuoteByUuidAction) {
  yield put({ type: FETCH_QUOTE_BY_UUID_START });

  try {
    const response = yield call(client.query, {
      query: QUOTE_BY_UUID,
      variables: {
        quoteUuid: payload.quoteUuid,
      },
      fetchPolicy: 'network-only',
    });

    const [quote] = response.data.quotes || [];
    yield put({
      type: FETCH_QUOTE_BY_UUID,
      payload: quote,
    });
  } catch (error) {
    yield put({
      type: FETCH_QUOTE_BY_UUID_ERROR,
      payload: error,
    });
  }
}

export default function* quotesSaga() {
  yield takeLatest(GET_QUOTE_FOR_REQUEST, fetchQuoteForRequestSaga);
  yield takeLatest(GET_PUBLIC_QUOTE, fetchPublicQuoteSaga);
  yield takeLatest(GET_QUOTE_BY_UUID, fetchQuoteByUuidSaga);
}
